import {
  DocumentIcon,
  PhotoIcon,
  VideoCameraIcon,
  CodeBracketIcon,
  ArrowDownTrayIcon,
} from '@heroicons/react/24/outline'

const FILE_TYPE_ICONS = {
  image: PhotoIcon,
  video: VideoCameraIcon,
  document: DocumentIcon,
  code: CodeBracketIcon,
  other: DocumentIcon,
}

export default function SubmittedFilesDisplay({ files }) {
  if (!files || files.length === 0) {
    return null
  }

  return (
    <div className="mt-6">
      <h4 className="text-sm font-semibold text-gray-700 mb-3">Submitted Files</h4>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {files.map((file) => {
          const Icon = FILE_TYPE_ICONS[file.file_type] || DocumentIcon
          const isImage = file.file_type === 'image'
          
          return (
            <div
              key={file.id}
              className="bg-white border border-gray-200 rounded-lg p-4 hover:border-green-300 hover:shadow-md transition-all group"
            >
              {/* Image Preview */}
              {isImage && file.url && (
                <div className="mb-3 rounded-lg overflow-hidden bg-gray-100">
                  <img
                    src={file.url}
                    alt={file.original_name}
                    className="w-full h-32 object-cover"
                  />
                </div>
              )}
              
              {/* File Info */}
              <div className="flex items-start space-x-3">
                {!isImage && <Icon className="h-10 w-10 text-gray-400 flex-shrink-0 mt-1" />}
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium text-gray-900 truncate group-hover:text-green-600 transition-colors">
                    {file.original_name}
                  </p>
                  <p className="text-xs text-gray-500 mt-1">
                    {file.formatted_size || file.size}
                  </p>
                  {file.description && (
                    <p className="text-xs text-gray-600 mt-2 italic">
                      {file.description}
                    </p>
                  )}
                </div>
                <a
                  href={file.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex-shrink-0 p-2 text-green-600 hover:bg-green-50 rounded-lg transition-colors"
                  title="Download"
                >
                  <ArrowDownTrayIcon className="h-5 w-5" />
                </a>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
